import React, { useEffect, useRef } from "react";
import { TextB, TextItalic, TextUnderline, TextHFour, Paragraph, ListBullets, ListNumbers } from "@phosphor-icons/react";

const TOOLS = [
  ["bold", null, TextB, "Bold"],
  ["italic", null, TextItalic, "Italic"],
  ["underline", null, TextUnderline, "Underline"],
  ["formatBlock", "h4", TextHFour, "Sub-heading"],
  ["formatBlock", "p", Paragraph, "Normal text"],
  ["insertUnorderedList", null, ListBullets, "Bullet list"],
  ["insertOrderedList", null, ListNumbers, "Numbered list"],
];

export function RichTextEditor({ value, onChange, testId, minHeight = 120 }) {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) ref.current.innerHTML = value || "";
  }, [value]);
  const run = (cmd, arg) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    onChange(ref.current.innerHTML);
  };
  return (
    <div className="border border-neutral-200 rounded-md bg-white focus-within:border-neutral-400 transition-colors" data-testid={testId}>
      <div className="flex flex-wrap gap-0.5 px-1.5 py-1 border-b border-neutral-100 bg-neutral-50 rounded-t-md">
        {TOOLS.map(([cmd, arg, Icon, label]) => (
          <button key={label} type="button" title={label} data-testid={`${testId}-tool-${label.toLowerCase().replace(/ /g, "-")}`}
            onMouseDown={(e) => { e.preventDefault(); run(cmd, arg); }}
            className="p-1.5 rounded text-neutral-500 hover:bg-neutral-200 hover:text-neutral-900">
            <Icon size={14} weight="bold" />
          </button>
        ))}
      </div>
      <div ref={ref} contentEditable suppressContentEditableWarning data-testid={`${testId}-input`}
        onInput={(e) => onChange(e.currentTarget.innerHTML)}
        className="wo-rich px-3 py-2 text-sm text-neutral-800 outline-none" style={{ minHeight }} />
    </div>
  );
}
